export const API = {
    BASE_URL: "https://32kluyld4h.execute-api.us-east-1.amazonaws.com/prod/"
}